/* ------------------- IMPORTS */
import { MultiSelectRow } from 'components/UI/MultiSelectRow'
import { useCalendarStore } from 'stores/CalendarStore'
import { T } from 'utils'

/* ------------------- TYPES  */

/* ------------------- INTERFACES  */

interface Props {}

export const CreatedFilterCalendar = ({}: Props) => {
  /* ----------------- STATE  */

  /* ----------------- REF  */

  /* ----------------- ZUSTAND  */
  const { createdFrom } = useCalendarStore((s) => ({ createdFrom: s.createdFrom }))

  const { setCreatedFrom } = useCalendarStore()

  /* ----------------- VARIABLES  */

  /* ----------------- METHODS  */

  /* ----------------- API CALL  */

  /* ----------------- USEEFFECT  */

  /* ----------------- CONFIG  */
  const data = [
    {
      name: T.status.all,
      value: 'all',
      action: () => setCreatedFrom('all'),
    },
    {
      name: T.calendarPage.manual,
      value: 'manual',
      action: () => setCreatedFrom('manual'),
    },
    {
      name: T.calendarPage.autopilot,
      value: 'autopilot',
      action: () => setCreatedFrom('autopilot'),
    },
  ]

  return <MultiSelectRow active={createdFrom} options={data} />
}
